/*
 * Externally authored animation. Re-export from the source rather than editing this file directly.
 */
import { Box } from '@mui/material';

import styles from './PullCordAnimation.module.css';

export default function PullCordAnimation() {
    return (
        <Box
            sx={{
                width: '100%',
                py: 2,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden',
                borderRadius: 2,
                bgcolor: 'neutral.100',
            }}
        >
            {/* Zoom, not transform: the panel needs to see the scaled height. 260px of 460. */}
            <Box sx={{ zoom: 0.565 }}>
                <div className={styles['lever-widget']}>
                    <div className={styles.plate}>
                        <div className={styles.stack}>
                            <div className={styles.screw} />
                            <div className={styles.led} />
                            <div className={styles.recess}>
                                <div className={styles.track}>
                                    <div className={styles.lever}>
                                        <div className={styles.label}>
                                            <span>Emergency</span>
                                        </div>
                                        <div className={styles.chevron} aria-hidden="true">
                                            <svg
                                                width="80"
                                                height="44"
                                                viewBox="0 0 120 80"
                                                fill="none"
                                            >
                                                <path
                                                    d="M20 66 L60 18 L100 66"
                                                    stroke="white"
                                                    strokeOpacity="0.85"
                                                    strokeWidth="14"
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </div>
                                        <div className={styles.grip} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Box>
        </Box>
    );
}
